import React, { useRef, useCallback } from 'react';
import { Controller } from 'react-hook-form';
import JoditEditor from 'jodit-react';
import { FormLabel } from './FormLabel';
import debounce from 'lodash.debounce'; // Ensure lodash.debounce is installed

const FormRichTextBox = ({ control, name, label, rules, defaultValue, limitChars, insertOnlyText, id, ...props }) => {
  const editorRef = useRef(null);

  const config = {
    limitChars: limitChars,
    toolbarButtonSize: 'small',
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: insertOnlyText ? 'insert_only_text' : undefined,
    buttons:
      'bold,underline,italic,eraser,|,superscript,subscript,|,ul,ol,|,outdent,indent,|,font,fontsize,brush,paragraph,|,link,|,align,undo,redo,selectall,cut,copy,paste,copyformat,|,hr,symbol,fullsize,print,about',
  };

  const handleDebouncedChange = useCallback(
    debounce((onChange, value) => {
      onChange(value);
    }, 500),
    []
  );

  // Ensure the editor is properly initialized and connected to the ref
  const setEditorRef = useCallback((instance) => {
    if (instance) {
      editorRef.current = instance;
    }
  }, []);

  return (
    <div id={id}>
      {label && <FormLabel rules={rules} label={label} id={id} />}
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field: { onChange, onBlur, value, ref }, fieldState }) => (
          <>
            <JoditEditor
              ref={setEditorRef}
              value={value || ''}
              config={config}
              onBlur={onBlur}
              onChange={(newContent) => handleDebouncedChange(onChange, newContent)}
              {...props}
            />
            {fieldState.error && <div className="text-danger">{fieldState.error.message}</div>}
          </>
        )}
      />
    </div>
  );
};

export default FormRichTextBox;
